module.exports = __webpack_public_path__ + "static/assets/4936485ece34a75e07e8be5ac4ed31c8.png";